import api from '@/services/api/api'

class ChangePasswordService {
  changePassword (oldPassword, newPassword, confirmPassword) {
    return api.post('user/change-password',
      { oldPassword: oldPassword, newPassword: newPassword, confirmPassword: confirmPassword })
      .then(response => {
        return response.data
      })
  }
}

export default new ChangePasswordService()



// WEBPACK FOOTER //
// ./src/services/user/ChangePasswordService.js